import React, { useState, useEffect } from "react"
import "./Footer.scss"
import { Link, graphql, useStaticQuery } from "gatsby"
import useBrandInfo from "@hooks/dataHooks/useBrandInfo"
import CookieConsent from "react-cookie-consent"
import CTALink from "@components/elements/CTALink"
import GlobalFormModal from "@components//PopupForms/GlobalFormModal"
import { isEmpty } from "lodash"
import FacebookIcon from "@components/icons/FacebookIcon"
import TwitterIcon from "@components/icons/TwitterXIcon"
import InstaIcon from "@components/icons/InstaIcon"
import LinkedInIcon from "@components/icons/LinkedInIcon"
import YoutubeIcon from "@components/icons/YoutubeIcon"
import FooterPopularSearches from "@components/FooterPopularSearches/FooterPopularSearches"
import { parseHTML } from "@lib/utils"
import { cookiePolicyURL } from "@lib/urls"
import { Container } from "react-bootstrap"
import "@styles/cookie-popup.scss"

export const SocialIcons = () => {
  const {
    facebookLink,
    instagramLink,
    linkedinLink,
    twitterLink,
    youtubeLink,
  } = useBrandInfo()

  return (
    <nav className="social-icons-section">
      <a
        href={facebookLink}
        target="_blank"
        rel="noreferrer"
        aria-label="Facebook"
      >
        <FacebookIcon />
      </a>
      <a
        href={instagramLink}
        target="_blank"
        rel="noreferrer"
        aria-label="Instagram"
      >
        <InstaIcon />
      </a>
      <a
        href={twitterLink}
        target="_blank"
        rel="noreferrer"
        aria-label="Twitter"
        className="scl_cls"
      >
        <TwitterIcon />
      </a>
      <a
        href={linkedinLink}
        target="_blank"
        rel="noreferrer"
        aria-label="LinkedIn"
      >
        <LinkedInIcon />
      </a>
      <a
        href={youtubeLink}
        target="_blank"
        rel="noreferrer"
        aria-label="Youtube"
      >
        <YoutubeIcon />
      </a>
    </nav>
  )
}

const Footer = ({ popularSearch, popularSearchDetailsObject, popularSearchObject }) => {
  const data = useStaticQuery(graphql`
    query {
      strapiGlobalMenu {
        footer_links {
          id
          title
          strapi_id
          ctas {
            ...ctaFragment
          }
        }
      }
        
      strapiClientLogo {
        show_on_website
        client_logo {
          logo {
            url
            alternativeText
          }
        }
      }
    }
  `)

  const footerLinks = data?.strapiGlobalMenu?.footer_links
  const brandLogo = data?.strapiClientLogo

  const { footerLogo, footerCopyright } = useBrandInfo()
  

  return (
    <footer className="footer-wrap section-p">
      <Container>
        <GlobalFormModal />
        <div className="footer-top">
          <section className="centenary-section">
            <img src={footerLogo} alt="centenary-icon" />
            <p className="centenary-text">
              Celebrating Webbers <i>100 Years</i> Centenary
            </p>
          </section>
          <section className="footer-links-wrap">
            {footerLinks?.map(({ id, title, ctas }) => {
              return (
                <div key={id} className="footer-links-section">
                  <h4 className="link-title">{title}</h4>
                  <nav className="footer-links">
                    {!isEmpty(ctas) &&
                      ctas?.map((cta) => {
                        return (
                          <CTALink
                            cta={cta}
                            key={cta.id}
                            className="footer-link"
                          />
                        )
                      })}
                  </nav>
                </div>
              )
            })}
          </section>
        </div>
        {brandLogo.show_on_website && (
          <div className="brand-logos">
            {brandLogo?.client_logo?.length > 0 &&
              brandLogo?.client_logo.map((item) => (
                <img src={item.logo.url} alt="client-logo" key="" />
              ))}
          </div>
        )}
        <section className="copyright-icons-section">
          <SocialIcons />
          <div className="copyright-section">{parseHTML(footerCopyright)}</div>
        </section>
        <FooterPopularSearches popularSearch={popularSearch} popularSearchDetailsObject={popularSearchDetailsObject} popularSearchObject={popularSearchObject} />

        <CookieConsent
          disableStyles
          buttonClasses="btn btn-primary btn-link gotit"
          containerClasses="cookie-popup"
          buttonWrapperClasses="cook_txt"
          buttonText="Accept Cookies"
          contentClasses="cook_txt"
          cookieName={process.env.GATSBY_SITE_NAME}
        >
          We use cookies to ensure that we give you the best experience on our
          website. By continuing to use our site, you are confirming acceptance
          of these cookies. You can change your cookie settings at any time.{" "}
          <Link to={`${cookiePolicyURL}`}>Click here to find out more.</Link>
        </CookieConsent>
      </Container>
    </footer>
  )
}

export default Footer
